import { memo } from 'react';
import dynamic from 'next/dynamic';
import cn from 'classnames';
import { Container, Element, Icon, RouterLink } from 'src/components';
import Level from 'src/components/grid/level';
import Nossr from 'src/components/nossr';
import { IFooter } from 'src/interface';
import { ArrayUtils } from 'src/utils';

const LINK_DOWNLOAD_APP = 'https://baomoi.onelink.me/Dfp0/1e035efe';

const SlideFooter = dynamic(() => import('./slide'), {
    ssr: false,
});

function Footer({ footer }: { footer: IFooter }) {
    let { tags = [], customTags = [] } = footer || {};
    const _tags = [...tags, ...customTags];

    return (
        <Element renderAs="footer" className={cn('bm-footer', 'pt-[20px]')}>
            <RouterLink
                to={LINK_DOWNLOAD_APP}
                className={cn(
                    'link-download',
                    'relative block',
                    'py-[16px]',
                    'bg-[#f8f9fa]',
                    'border-t border-solid border-[#edeff2]'
                )}
            >
                <Container>
                    <Level>
                        <Level.Item className="!mr-[12px]">
                            <Icon type="bm" icon="baomoi-app" />
                        </Level.Item>
                        <Level.Item
                            className={cn('app-text', 'flex-col items-start')}
                        >
                            <Element
                                className={cn(
                                    'text-[1.6rem]',
                                    'pt-[4px]',
                                    'uppercase'
                                )}
                                renderAs="span"
                            >
                                Tải ứng dụng báo mới
                            </Element>
                            <Element
                                className={cn(
                                    'text-[1.1rem]',
                                    'pt-[4px]',
                                    'uppercase'
                                )}
                                renderAs="span"
                            >
                                Để không bỏ sót tin tức
                            </Element>
                        </Level.Item>
                        <Level.Item>
                            <Icon
                                className={cn(
                                    'w-[50px] h-[50px]',
                                    'text-[2rem]',
                                    'flex items-center justify-center',
                                    'rounded-[3px]',
                                    'bg-[#e9ecef]'
                                )}
                                icon="cloud-download"
                            />
                        </Level.Item>
                    </Level>
                </Container>
            </RouterLink>
            <Element
                className={cn(
                    'flex',
                    'px-[16px]',
                    'border-t border-b border-solid border-[#e9ecef]',
                    'font-semibold'
                )}
            >
                <RouterLink
                    className={cn(
                        'flex items-center justify-center',
                        'w-1/2',
                        'py-[16px]'
                    )}
                    to="/staticpages/termsofuse.epi"
                    newTab
                >
                    <Icon
                        className={cn(
                            'w-[20px] h-[20px]',
                            'bg-[url(https://baomoi-static.bmcdn.me/web/styles/img/ic-term.svg)]',
                            'bg-cover bg-no-repeat',
                            'mr-[10px]'
                        )}
                    />
                    Điều khoản sử dụng
                </RouterLink>
                <RouterLink
                    className={cn(
                        'flex items-center justify-center',
                        'w-1/2',
                        'py-[16px]'
                    )}
                    to="/staticpages/privacy.epi"
                    newTab
                >
                    <Icon
                        className={cn(
                            'w-[20px] h-[20px]',
                            'bg-[url(https://baomoi-static.bmcdn.me/web/styles/img/ic-policy.svg)]',
                            'bg-cover bg-no-repeat',
                            'mr-[10px]'
                        )}
                    />
                    Chính sách bảo mật
                </RouterLink>
            </Element>
            {!ArrayUtils.isEmpty(_tags) && (
                <>
                    <Container>
                        <Element
                            className={cn(
                                'text-center',
                                'mt-[15px] mx-0 pb-[10px]',
                                'border-b-[#eee] border-b border-solid'
                            )}
                        >
                            {_tags?.map((item: any, index: number) => {
                                return (
                                    <span
                                        className={cn(
                                            'inline-block text-[1.3rem] text-[#6c757d] capitalize',
                                            "before:content-['•']  before:inline-block",
                                            'before:text-[0.8rem] before:leading-[18px] before:text-[#ccc]',
                                            'before:px-[6px] before:py-0'
                                        )}
                                        key={index}
                                    >
                                        <RouterLink
                                            to={item.url}
                                            title={item.name}
                                        >
                                            {item.name}{' '}
                                        </RouterLink>
                                    </span>
                                );
                            })}
                        </Element>
                    </Container>
                </>
            )}
            <Container>
                <Element
                    className={cn(
                        'copyright-wrapper',
                        'text-[1.4rem] leading-[22px] text-center text-[#6c757d]',
                        'pt-[20px] pb-[60px]',
                        'before:w-[100px] before:h-[1px] before:block before:bg-[#495057]',
                        'before:mb-[10px] before:mx-auto'
                    )}
                >
                    <Nossr>
                        <p>
                            Giấy phép thiết lập trang thông tin điện tử <br />
                            tổng hợp số 1818/GP-TTĐT do Sở Thông tin và Truyền
                            thông Hà Nội cấp ngày 05/05/2017
                            <br />
                            Đơn vị thiết lập: Công ty cổ phần công nghệ EPI
                            <br />
                            Chịu trách nhiệm quản lý nội dung: Vũ Trọng Cường
                            <br />
                            Địa chỉ: Tầng 16, Tòa nhà ROX Tower, số 54A Nguyễn Chí Thanh, Phường Láng, Thành phố Hà Nội
                            <br />
                            Tel: (024) 3-542-3555
                            <br />
                            Email: contact.baomoi@epi.com.vn
                            <br />
                            BAOMOI tổng hợp và sắp xếp các thông tin tự động bởi
                            chương trình máy tính
                        </p>
                    </Nossr>
                </Element>
            </Container>
            <SlideFooter />
        </Element>
    );
}

export default memo(Footer);
